import { CellClickedEvent, ColDef } from "ag-grid-community";
import { useMemo } from "react";
import type { FhirSectionProps } from "../fhir-section";
import FhirSection from "../fhir-section";
import { CarePlanRowData } from "./table-data";

function CarePlansSection(props: FhirSectionProps) {
  const futureActivitiesFilter = useMemo(
    () => [
      {
        label: "Upcoming Only",
        isChecked: true,
        filterFn: (rowData: CarePlanRowData) => rowData.isUpcoming,
      },
    ],
    []
  );

  const defaultColDef: ColDef = {
    flex: 1,
    onCellClicked: (event: CellClickedEvent) => props.handleCellClick(props.sectionId, event),
    cellStyle: props.handleCellStyle,
  };

  return (
    <FhirSection {...props} defaultColDef={defaultColDef} filterToggles={futureActivitiesFilter} />
  );
}

export default CarePlansSection;
